import { render, staticRenderFns } from "./winners.vue?vue&type=template&id=0e8004e3"
import script from "./winners.vue?vue&type=script&lang=js"
export * from "./winners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports